import React, {useState, useEffect} from "react";
import { useSelector} from "react-redux";
import WidgetCard from "./card";
import { FormattedMessage } from "react-intl";
import "./widgetCheckup.css";
import "./widgetCrisisCompanies.css";
import SimpleLoader from "../general/loader/index";
import { finalAndMoreRatingsColors } from "../../constants/checkup";
import { Pagination } from "antd";
import HumanImg from "../../assets/img/human-checkup.svg";

const WidgetCrisisCompanies = props => {

  const companiesCrisisList = useSelector(state => state.rating?.crisisCompanies?.data?.data);
  const companiesCrisisStatus = useSelector(state => state.rating?.crisisCompanies?.status);
  const companiesObject = useSelector(state => state.rating?.crisisCompanies?.data);

  const [currentPage, setCurrentPage] = useState(1);
  const [minIndex, setMinIndex] = useState(0);
  const [maxIndex, setMaxIndex] = useState(0);

  const pageSize = 5;

  const getFinalAndMoreRatingColor = (finalRating) => {
    return finalAndMoreRatingsColors[finalRating];
  };

  const handleChange = (page) => {
    setCurrentPage(page);
    setMinIndex((page - 1) * pageSize);
    setMaxIndex(page * pageSize);
  };

  useEffect(() => {
    setMaxIndex(pageSize);
  }, []);

  return (
    companiesCrisisStatus.started ?
      <WidgetCard
        type={"box1_3"}
        titleWidget={
          <div>
            <FormattedMessage id="checkup.crisisCompanies" />
          </div>
        }
        customTitle={"noCapitalizeTitle"}
        footer={null}
      >
        <div className='crisisCompaniesTable'>
          <div className='crisisCompaniesRow'>
            <div><FormattedMessage id="generic.businessName" /></div>
            <div>Rating</div>
          </div>
          <SimpleLoader></SimpleLoader>
        </div>
      </WidgetCard>
      // companiesObject:{dataElaborazione: xxxxxxxx, data: {xxxxxxxxxxx}} se ci sono dati
      // altrimenti companiesObject = {}
      : Object.keys(companiesObject).length > 0 ?
        <WidgetCard
          type={"box1_3"}
          titleWidget={
            <div>
              <FormattedMessage id="checkup.crisisCompanies" />
            </div>
          }
          customTitle={"noCapitalizeTitle"}
          footer={null}
        >
          <div className='crisisCompaniesTable'>
            <div className='crisisCompaniesRow'>
              <div><FormattedMessage id="generic.businessName" /></div>
              <div>Rating</div>
            </div>

            {

              companiesCrisisList?.map((company, index) =>
                (index >= minIndex && index < maxIndex &&

                <div key={"crisis " + company.ragionesocialecliente} className='crisisCompaniesRow' style={{borderTop: "1px solid rgb(234, 234, 245)", borderBottom: "1px solid rgb(234, 234, 245)"}}>

                  <div>{company.ragionesocialecliente}</div>
                  <div>
                    <div><div className = 'mediumSpot' style= {{
                      backgroundColor: getFinalAndMoreRatingColor(company.CrisiScore)
                    }}></div></div>
                    <div style={{paddingLeft: "8px"}}>{company.CrisiScore}</div>
                  </div>
                </div>

                ))}
            <div>
              <Pagination
                size="small"
                pageSize={pageSize}
                current={currentPage}
                total={companiesCrisisList.length}
                onChange={handleChange}
                hideOnSinglePage={true}
              /></div>
          </div>
        </WidgetCard>
        :
        <WidgetCard
          type={"box1_3"}
          titleWidget={
            <div>
              <FormattedMessage id="checkup.crisisCompanies" />
            </div>
          }
          customTitle={"noCapitalizeTitle"}
          footer={null}
        >
          <div style={{padding: "20px"}}>
            <div className='placeholderCrisiTitle'><FormattedMessage id="checkup.monitoringCompanies" /></div>
            <div className='placeholderCrisi'>
              <FormattedMessage id="checkup.noAnalysisCrisis" />
            </div>
            <div style={{ textAlign: "right", marginRight: "5px" }}>
              <img src={HumanImg} alt=""></img>
            </div>
          </div>

        </WidgetCard>
  );
};

export default WidgetCrisisCompanies;
